export default __webpack_public_path__ + "./image/67f829a47930d58c39aca9db01b1fe8a.png";